import axios from 'axios';
import {baseUrl} from "./baseUrl";

// 登录请求方法
const loginreq = (method, url, params) => {
  url = replaceUndefined(url)
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      // 'Authorization': 'Bearer '+localStorage.getItem('logintoken'),
      'X-Client-Id': 'zr_platform',
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => {
    return res.data;
  });
};

// 通用公用方法
const reqHeader = (method, url, params,headers) => {
  url = replaceUndefined(url)
  return axios({
    method,
    url,
    headers,
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
  url = replaceUndefined(url)
  
  // 获取客户端ID
  const clientId = localStorage.getItem('X-Client-Id') || 'zr_platform';
  
  // 获取用户ID
  const userId = Boolean(localStorage.getItem("userdata")) ? 
    JSON.parse(localStorage.getItem("userdata")).userId : '';
  
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer ' + localStorage.getItem('logintoken'),
      'X-Client-Id': 'zr_platform',
      'X-User-Id': Boolean(localStorage.getItem("userdata")) ? JSON.parse(localStorage.getItem("userdata")).userId : ''
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => {
    // 保存响应中的X-Client-Id（如果有的话）
    const responseClientId = res.headers && res.headers['X-Client-Id'];
    if (responseClientId) {
      localStorage.setItem('X-Client-Id', responseClientId);
    }
    
    // 处理大整数问题：特别是针对ID类型的字段
    const responseData = res.data;
    
    // 特殊处理：如果响应直接是一个数值，且非常大的整数，可能是ID
    if (typeof responseData === 'number' && responseData > Number.MAX_SAFE_INTEGER) {
      return responseData.toString();
    }
    
    // 如果是对象且有data字段，且data是大整数
    if (responseData && typeof responseData === 'object' && 
        typeof responseData.data === 'number' && 
        responseData.data > Number.MAX_SAFE_INTEGER) {
      responseData.data = responseData.data.toString();
    }
    
    return responseData;
  }).catch(error => {
    return Promise.reject(error);
  });
};
// json通用公用方法
const reqJson = (method, url, params) => {
  url = replaceUndefined(url)
  
  
  // 获取客户端ID
  const clientId = localStorage.getItem('X-Client-Id') || 'zr_platform';
  
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+localStorage.getItem('logintoken'),
      'X-Client-Id': 'zr_platform'
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        if (data === null || data === undefined) {
          return '{}';
        }
        
        if (Array.isArray(data)) {
          console.warn('收到了数组类型的请求数据，可能导致错误:', data);
          // 如果是数组，包装在一个对象中
          return JSON.stringify({ data: data });
        }
        
        // 正常情况，直接返回对象
        return JSON.stringify(data);
      }
    ]
  }).then(res => {
    // 保存响应中的X-Client-Id（如果有的话）
    const responseClientId = res.headers && res.headers['X-Client-Id'];
    if (responseClientId) {
      localStorage.setItem('X-Client-Id', responseClientId);
    }
    
    // 处理响应数据
    const responseData = res.data;
    
    // 记录响应

    
    // 统一处理特殊的嵌套错误响应结构：{code: 200, data: {code: 400, message: "错误信息"}}
    if (responseData && 
        responseData.code === 200 && 
        responseData.data && 
        typeof responseData.data === 'object' && 
        responseData.data.code === 400) {
      
      console.warn('检测到嵌套错误响应:', responseData);
      // 替换成统一的错误格式
      return {
        code: responseData.data.code,
        message: responseData.data.message || '请求失败',
        originalResponse: responseData
      };
    }
    
    return responseData;
  }).catch(error => {
    console.error('请求失败:', error, '请求URL:', url, '请求参数:', params);
    // 重新抛出错误，保持现有行为
    throw error;
  });
};

// 文件类型通用公用方法
const reqFile = (method, url, params) => {
  url = replaceUndefined(url)
  console.log(`开始${method.toUpperCase()}文件上传请求: ${url}`);
  
  // 检查是否是FormData类型
  const isFormData = params instanceof FormData;
  
  // 获取客户端ID
  const clientId = localStorage.getItem('X-Client-Id') || 'zr_platform';
  
  // 对于FormData，不要设置Content-Type，让浏览器自动设置multipart/form-data和边界
  const headers = isFormData 
    ? {
        'Authorization': 'Bearer ' + localStorage.getItem('logintoken'),
        'X-Client-Id': clientId
      } 
    : {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('logintoken'),
        'X-Client-Id': clientId
      };
  
  // 调试输出
  if (isFormData) {
    console.log('检测到FormData类型数据');
    // 列出FormData中的所有字段
    for (let pair of params.entries()) {
      if (pair[0] === 'chunk' && pair[1] instanceof File) {
        console.log(`FormData字段: ${pair[0]}, 类型: File, 大小: ${pair[1].size} bytes, 名称: ${pair[1].name}`);
      } else {
        console.log(`FormData字段: ${pair[0]}, 值: ${pair[1]}`);
      }
    }
  }
  
  return axios({
    method: method,
    url: url,
    headers: headers,
    data: params,
    processData: false,  // 对于FormData类型，不处理数据
    contentType: false,  // 对于FormData类型，不设置内容类型
    transformRequest: isFormData 
      ? undefined  // 对于FormData类型，不转换请求数据
      : [
          function (data) {
            let ret = data
            return ret
          }
        ]
  }).then(res => {
    console.log(`${method.toUpperCase()}文件上传响应: ${url}`, res.data);
    return res.data;
  }).catch(error => {
    console.error('文件上传请求失败:', error, '请求URL:', url);
    throw error;
  });
};


// 文件类型通用公用方法
const reqLogin = (method, url, params) => {
  url = replaceUndefined(url)
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'X-Client-Id': 'zr_platform',
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = data
        return ret
      }
    ]
  }).then(res => res);
};
//移除undefined传参
const replaceUndefined = (url) => {
  if (url.indexOf("undefined") > -1) {
    url = url.replace("undefined", "");
  }

  // 如果是相对路径且不是以/开头，自动添加/
  if (!url.startsWith("http://") && !url.startsWith("https://") && !url.startsWith("/")){
    url = "/" + url;
  }

  // 如果是API路径但不包含zrsystem前缀且不是完整URL，添加zrsystem前缀
  if (!url.startsWith("http://") && !url.startsWith("https://") &&
      (url.startsWith("/admin") || url.startsWith("/shopping") ||
       url.startsWith("/security") || url.startsWith("/message") ||
       url.startsWith("/task")) && !url.includes("/zrsystem")) {
    url = "/zrsystem" + url;
  }

  return url
};

// GET请求
const axiosGet = (url, params) => {
  url = replaceUndefined(url);
  
  let queryString = '';
  if (params) {
    queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key] || '')}`)
      .join('&');

    url += (url.includes('?') ? '&' : '?') + queryString;
  }


  return axios({
    method: 'get',
    url: baseUrl + url,
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('logintoken'),
      'X-Client-Id': 'zr_platform',
      'X-User-Id': Boolean(localStorage.getItem("userdata")) ? JSON.parse(localStorage.getItem("userdata")).userId : ''
    }
  }).then(res => res.data);
};

// POST请求
const axiosPost = (url, params, config = {}) => {
  url = replaceUndefined(url);
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('logintoken'),
    'X-Client-Id': 'zr_platform',
    'X-User-Id': Boolean(localStorage.getItem("userdata")) ? JSON.parse(localStorage.getItem("userdata")).userId : ''
  };

  // 合并自定义headers
  if (config.headers) {
    Object.assign(headers, config.headers);
  }

  return axios({
    method: 'post',
    url: baseUrl + url,
    headers: headers,
    data: params
  }).then(res => res.data);
};

// PUT请求
const axiosPut = (url, params) => {
  url = replaceUndefined(url);
  return axios({
    method: 'put',
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('logintoken'),
      'X-Client-Id': 'zr_platform',
      'X-User-Id': Boolean(localStorage.getItem("userdata")) ? JSON.parse(localStorage.getItem("userdata")).userId : ''
    },
    data: params
  }).then(res => res.data);
};

// DELETE请求
const axiosDelete = (url, params) => {
  url = replaceUndefined(url);
  return axios({
    method: 'delete',
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('logintoken'),
      'X-Client-Id': 'zr_platform',
      'X-User-Id': Boolean(localStorage.getItem("userdata")) ? JSON.parse(localStorage.getItem("userdata")).userId : ''
    },
    data: params
  }).then(res => res.data);
};
const reqJsonAuto = (method, url, params) => {
  url = replaceUndefined(url)
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+localStorage.getItem('logintoken'),
      'X-Client-Id': 'zr_platform'
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        // 如果数据已经是字符串，直接返回
        if (typeof data === 'string') {
          return data;
        }
        // 否则将对象序列化为 JSON 字符串
        return JSON.stringify(data);
      }
    ]
  }).then(res => res.data);
};
export {
  loginreq,
  req,
  reqJson,
  reqJsonAuto,
  reqHeader,
  reqFile,
  reqLogin,
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete
};



// WEBPACK FOOTER //
// ./src/api/axiosFun.js